
AGADash.Panel.Tools = (function () {
    var buttonNames = {
        minimize: "minimize",
        resize: "resize",
        reload: "reload",
        remove: "remove"
    };

    var classNames = {
        minimize: "aga-tool aga-minimize",
        resize: "aga-tool aga-resize",
        reload: "aga-tool aga-reload",
        remove: "aga-tool aga-remove"
    };

    var handlers = {
        minimize: function () {},
        resize: function(e) {
            var isFullNow= AGADash.Panel.toggleFullWidth(e.currentTarget);
            $(e.currentTarget).toggleClass("aga-fullwidth", isFullNow)
                .toggleClass("aga-halfwidth", !isFullNow);
        },
        reload: function (e) { AGADash.Panel.updatePanel(e.currentTarget); },
        remove: function (e) { AGADash.Panel.remove(e.currentTarget); }
    };

    // ---- A partir deste ponto não deveria existir alterações ---------------

    var handlersInited = false;

    var handleClick = function (e) {
        var name = $(e.currentTarget).data("toolname");
        AGADash.Events.anyInvoke(name, e.currentTarget);
        var handler = handlers[name];
        handler(e);
    };

    var initHandlers = function () {
        if (handlersInited) return;
        $("body").on("mouseup", ".aga-tool", handleClick);
        handlersInited = true;
    };

    var render = function (parent, buttonName, additionalClasses) {
        initHandlers();
        var cl = classNames[buttonName] + " " + additionalClasses;
        var a = document.createElement("a");
        $(a).addClass(cl)
            .attr({ "href": "javascript:;" })
            .data("toolname", buttonName)
            .appendTo(parent);
        return a;
    };

    var registerEvents = function() {
        for (var n in buttonNames) {
            if (buttonNames.hasOwnProperty(n)) {
                AGADash.Events.registerEventName(n);
            }
        }
    };

    return {
        registerEvents: registerEvents,
        buttonNames: buttonNames,
        render: render
        
    };

})();

AGADash.Repository.setPanelTools(AGADash.Panel.Tools);
AGADash.Panel.Tools.registerEvents();